import { Injectable } from '@angular/core';
import { UtysaServicePkg } from './utysaPkg.service';
import { Utysa } from '../_entity_uty';

@Injectable({
  providedIn: 'root',
})
export class UtysaService extends UtysaServicePkg {
  constructor() {
    super();
  }
override async newRecord(newItem: Utysa): Promise<Utysa> {
    let item = await super.newRecord(newItem);

    item.SA001 = this.linkKeyObj.SA001;
    item.SA002 = this.linkKeyObj.SA002;
    return item;
  }
}
